import { useEffect } from 'react';

export interface BodyLockHookOutput {
	/** Method to Enable Body Lock */
	enable: () => void;
	/** Method to Disable Body Lock */
	disable: () => void;
}

// export const useHideScroll = (hide?: boolean) => {
// 	useEffect(() => {
// 		const html = document.getElementsByTagName('html')[0];
// 		hide ? (html.style.overflow = 'hidden') : (html.style.overflow = '');
// 	}, [hide]);
// };

export const useHideScroll = (): BodyLockHookOutput => {
	const html = document.getElementsByTagName('html')[0];

	const enable = () => {
		html.style.overflow = '';
	};

	const disable = () => {
		html.style.overflow = 'hidden';
	};
	return {
		enable,
		disable,
	};
};
